import { render } from "./MyCertifications.vue?vue&type=template&id=e77361a4"
import script from "./MyCertifications.vue?vue&type=script&lang=js"
export * from "./MyCertifications.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Programación\\Desktop\\openbootcamp\\Vuejs\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__